module.exports = __webpack_public_path__ + "media/application/images/svgs/inbox-04ae82796b6650d95095f30c8b714cbe.svg";